export default [
    {
        id: "product",
        name: "产品管理",
        url: "/product/list",
    },
    {
        id: "battery",
        name: "电池管理",
        url: "/battery/list",
    },
    {
        id: "device",
        name: "设备管理",
        url: "/device/list",
    },
    {
        id: "email",
        name: "邮件发送记录",
        url: "/email/list",
    },
    {
        id: "tutorial",
        name: "新手教程",
        url: "/tutorial",
    },
    {
        id: "language",
        name: "语言管理",
        url: "/language/list",
    },
    {
        id: "permission",
        name: "权限管理",
        url: "/permission",
        children: [
            {
                id: "menu",
                name: "菜单管理",
                url: "/permission/menu/list",
            },
            {
                id: "role",
                name: "角色管理",
                url: "/permission/role/list",
            },
            {
                id: "admin",
                name: "管理员管理",
                url: "/permission/admin/list",
            },
            {
                id: "log",
                name: "日志管理",
                url: "/permission/log/list",
            },
        ],
    },
];
